import { TagProps, TooltipProps } from '@chakra-ui/react';
import { assertNever } from '@varos/util-typescript';
import { capitalize } from 'lodash';
import { ReportingControllerBaseConfig } from '../../base';
import { FormBlockController } from './formBlockInterface';
import { FormBlockViewProps } from './formBlockProps';
import { FormBlockAggregate } from './formBlockModel';
import { createBlockItemController } from '../block';
import { FaEye, FaTrash } from 'react-icons/fa';
import { HiCog } from 'react-icons/hi';
import { AiOutlineEye } from 'react-icons/ai';

export function createFormBlockController(
    config: ReportingControllerBaseConfig
): FormBlockController {
    const {
        kernel: {
            infra: { formatter },
        },
    } = config;
    const blockController = createBlockItemController();

    return {
        useProps(context, item, props): FormBlockViewProps {
            const block = blockController.useProps(context, item, props.item);
            return {
                label: item.form.id,
                block: {
                    ...block,
                    menu: {
                        ...block.menu,
                    },
                },
            };
        },
    };
}
